module.exports = __webpack_public_path__ + "img/main.a16fd160.jpg";